import React, { useContext } from 'react';
import { AdjustmentModal } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/RefactoredAdjustmentModals/AdjustmentModal';
import { useAppSelector } from 'src/utils/Hooks';
import * as serverProxy from '../RefactoredAdjustmentModals/serverProxy';
import { ForecastAdjustmentsTypeContext } from 'src/components/BeaconV2Components/ExperimentalLayout/ForecastAdjustmentsTypeProvider';
import CreateBulkAdjustmentButton from './CreateBulkAdjustmentButton';

export const CreateAdjustmentButton = () => {
  const { adjustmentModalOpen, setAdjustmentModalOpen } = useContext(ForecastAdjustmentsTypeContext);

  const retailerSku = useAppSelector((state) => state.entityService.mainEntity.retailerSku);
  const stacklineSku = useAppSelector((state) => state.entityService.mainEntity.stacklineSku);
  const categoryId = useAppSelector((state) => state.entityService.mainEntity.categoryId);
  const subcategoryId = useAppSelector((state) => state.entityService.mainEntity.subCategoryId);

  const handleClose = () => {
    setAdjustmentModalOpen(false);
  };
  return (
    <>
      <CreateBulkAdjustmentButton onAddSingularAdjustment={() => setAdjustmentModalOpen(true)} />
      <AdjustmentModal
        sendAdjustmentUpdate={serverProxy.createAdjustment}
        stacklineSku={stacklineSku}
        retailerSku={retailerSku}
        categoryId={categoryId}
        subcategoryId={subcategoryId}
        open={adjustmentModalOpen}
        onClose={handleClose}
      />
    </>
  );
};
